import { IntroCoverSlide } from "./slides/IntroCoverSlide";
import { IntroWhoWeAreSlide } from "./slides/IntroWhoWeAreSlide";
import { IntroApproachSlide } from "./slides/IntroApproachSlide";
import { IntroSecuritySlide } from "./slides/IntroSecuritySlide";
import { IntroTeamSlide } from "./slides/IntroTeamSlide";
import { IntroCTASlide } from "./slides/IntroCTASlide";

export const introSlideComponents = [
  IntroCoverSlide,
  IntroWhoWeAreSlide,
  IntroApproachSlide,
  IntroSecuritySlide,
  IntroTeamSlide,
  IntroCTASlide,
];
